// eslint-disable-next-line @typescript-eslint/naming-convention
export enum monitoringFiltersEnum {
    keywords = 'keywords',
    authors = 'authors',
    outlets = 'outlets',
    audience = 'audience',
    sentiment = 'sentiment',
    mediaTypes = 'mediaTypes', // must match socialFiltersEnum.networkType
    continent = 'continent',
    country = 'country',
    province = 'province',
    city = 'city',
    county = 'county',
    regions = 'regions',
    languages = 'language',
    duplicates = 'duplicates',
    ave = 'ave',
    folders = 'folders',
    tags = 'tags',
    tagGroups = 'tagGroups',
    agent = 'agent',
    theme = 'theme',
    sourceGroups = 'sourceGroups',
    hashtags = 'hashtags',
    searchedKeywords = 'searchedKeywords',
    prominence = 'prominence',
    dateRange = 'dateRange',
    domainAuthority = 'domainAuthority',
    engagementRate = 'engagementRate',
    engagementTotal = 'engagementTotal',
    savedFilters = 'savedFilters',
    discoverLists = 'discoverLists',
    aiAgent = 'aiAgent',
    aiAgentSource = 'aiAgentSource',
    aiAgentAdhoc = 'aiAgentAdhoc',
}
